<div #dropdown class="tab-overflow-menu lm_header" [hidden]="!showDropdown" appendTo="body">
  <ul class="bfx-filter-bar-options"></ul>
</div>
